import React, { useState } from 'react'
import { Modal, Box } from 'elements'
import ModalContent from '../../app/ModalContent'
import SelectTemplateModalHeader from './SelectTemplateModalHeader'
import SelectReportSections from './SelectReportSections'
import useReportTemplateUpdate from './hooks/useReportTemplateUpdate'
import AnimatedButtons from './AnimatedButtons'
import { useAnalytics } from 'hooks'

export default function SelectTemplateStep({
  currentTemplate,
  handleTemplateChange,
  configSections,
  setConfigSections,
  onBack,
  onClose,
  onNext,
  setTemplateStep,
  editing,
  closeAllOtherModals,
  defaultReportSections,
  defaultTemplate,
  organization,
}) {
  const [saving, setSaving] = useState(false)
  const [updateReportTemplate] = useReportTemplateUpdate()
  const analytics = useAnalytics()

  const blank = !configSections.length

  const handleSave = async () => {
    setSaving(true)

    const { reportTemplate } = await updateReportTemplate({
      id: currentTemplate.id,
      patch: {
        config: {
          sections: configSections,
        },
      },
    })

    analytics.track('Report Template Updated', {
      templateId: reportTemplate.rowId,
      organizationId: reportTemplate.organizationId,
      sectionNames: configSections.map((section) => section.name),
    })

    handleTemplateChange(reportTemplate)

    onNext()
  }

  return (
    <>
      <SelectTemplateModalHeader
        currentTemplate={currentTemplate}
        handleTemplateChange={handleTemplateChange}
        onClose={onClose}
        onBack={onBack}
        editing={editing}
        defaultTemplate={defaultTemplate}
        organization={organization}
      />
      <ModalContent>
        <SelectReportSections
          configSections={configSections}
          setConfigSections={setConfigSections}
          currentTemplate={currentTemplate}
          defaultReportSections={defaultReportSections}
          defaultTemplate={defaultTemplate}
        />
      </ModalContent>
      <Modal.Footer display="flex" alignItems="center" displayGradient>
        <Box positon="relative">
          <AnimatedButtons
            handleSave={handleSave}
            currentTemplate={currentTemplate}
            saving={saving}
            setTemplateStep={setTemplateStep}
            editing={editing}
            onNext={onNext}
            onClose={onClose}
            blank={blank}
            closeAllOtherModals={closeAllOtherModals}
          />
        </Box>
      </Modal.Footer>
    </>
  )
}
